// extracted by mini-css-extract-plugin
export default {"ticketDetailsContainer":"styles_ticketDetailsContainer__5j5fd","headerButtons":"styles_headerButtons__Frafa","ticketInfoCard":"styles_ticketInfoCard__Tmhds"};